import { Select } from "antd";
import React, { useCallback, useState } from "react";

const { Option } = Select;

const ChiNhanhXe = ({ setFieldsValue, name, value, type }) => {
  const onChange = useCallback(
    (values) => {
      if (type === "TicketFee") {
        !!setFieldsValue && setFieldsValue({ [name]: values.value });
      } else {
        !!setFieldsValue &&
          setFieldsValue({ vehicle: { branch: { [name]: values.value } } });
      }
    },
    [setFieldsValue, name, type]
  );

  return (
    <Select
      showArrow
      placeholder="Chi nhánh xe"
      labelInValue
      filterOption={false}
      onChange={onChange}
    >
      <Option value="all">Tất cả</Option>
      <Option value="HN">HN</Option>
      <Option value="DN">ĐN</Option>
      <Option value="HCM">HCM</Option>
    </Select>
  );
};

export default ChiNhanhXe;
